import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ROUTES } from '../../routes/paths';
import { Features } from '../../../assets/features/Features';
import { useLanguage } from '../../../context/LanguageContext';

// Pilates studio images
import pilates1 from '../../../assets/img/gallery/pilates/1.jpeg';
import pilates2 from '../../../assets/img/gallery/pilates/2.jpeg';
import pilates3 from '../../../assets/img/gallery/pilates/3.jpeg';
import pilates4 from '../../../assets/img/gallery/pilates/4.jpeg';
import pilates5 from '../../../assets/img/gallery/pilates/5.jpeg';
import pilates6 from '../../../assets/img/gallery/pilates/6.jpeg';
import pilates7 from '../../../assets/img/gallery/pilates/7.jpeg';
import pilates8 from '../../../assets/img/gallery/pilates/8.jpeg';
import pilates9 from '../../../assets/img/gallery/pilates/9.jpeg';

// Clinic images
import clinic9 from '../../../assets/img/gallery/9.jpeg';
import clinic10 from '../../../assets/img/gallery/10.jpeg';
import clinic11 from '../../../assets/img/gallery/11.jpeg';
import clinic12 from '../../../assets/img/gallery/12.jpeg';

const Gallery: React.FC = () => {
  const { language } = useLanguage();

  // Show a mix of pilates + clinic for the homepage preview (8 images)
  const galleryImages = [
    pilates1, clinic9, pilates2, clinic10,
    pilates3, clinic11, pilates4, clinic12,
  ];

  useEffect(() => {
    try {
      const GLightbox = require('glightbox');
      GLightbox({
        selector: '.gallery-lightbox',
        touchNavigation: true,
        loop: true,
        autoplayVideos: true,
        showTitle: false
      });
    } catch (error) {
      console.warn('GLightbox not available:', error);
    }
  }, []);

  return (
    <section id="gallery" className="gallery section">
      <div className="container section-title" data-aos="fade-up">
        <h2>{Features.gallery.title[language]}</h2>
        <p>{Features.gallery.subtitle[language]}</p>
      </div>

      <div className="container-fluid" data-aos="fade-up" data-aos-delay="100">
        <div className="row g-3">
          {galleryImages.map((src, index) => (
            <div className="col-lg-3 col-md-4 col-6" key={index}>
              <div className="gallery-item">
                <a
                  href={src}
                  className="gallery-lightbox glightbox"
                  data-gallery="gallery-home"
                >
                  <div className="gallery-img-wrapper">
                    <img src={src} alt={Features.gallery.imageAlt[language] + ` ${index + 1}`} />
                  </div>
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="text-center mt-5" data-aos="fade-up" data-aos-delay="200">
        <Link to={ROUTES.GALLERY} className="btn btn-outline-primary rounded-pill px-4 py-2">
          {Features.gallery.viewFullGalleryButton[language]}
        </Link>
      </div>

      <style>{`
        .gallery-item {
          position: relative;
          overflow: hidden;
          border-radius: 8px;
        }

        .gallery-img-wrapper {
          width: 100%;
          padding-top: 75%; /* 4:3 aspect ratio */
          position: relative;
          overflow: hidden;
        }

        .gallery-img-wrapper img {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          object-fit: cover;
          transition: transform 0.3s ease;
        }

        .gallery-item:hover .gallery-img-wrapper img {
          transform: scale(1.05);
        }

        .gallery-item a {
          display: block;
          cursor: pointer;
        }

        @media (max-width: 768px) {
          .glightbox-clean .gprev,
          .glightbox-clean .gnext {
            top: 50% !important;
            transform: translateY(-50%) !important;
            position: fixed !important;
            z-index: 999999 !important;
            display: flex !important;
            opacity: 1 !important;
          }

          .glightbox-clean .gprev {
            left: 10px !important;
          }

          .glightbox-clean .gnext {
            right: 10px !important;
          }

          .glightbox-clean .gprev svg,
          .glightbox-clean .gnext svg {
            width: 30px !important;
            height: 30px !important;
          }
        }
      `}</style>
    </section>
  );
};

export default Gallery;
